// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3gjq0","select":"Header_select__B1d8X","clinic":"Header_clinic__3r15H"};